<template>
    <div>
        <p>Initiating crawl</p>
    </div>
</template>
<script>

    export default {
        props: ['url'],
        mounted() {
            axios.post('/api/free', {
                url: this.url
            }).then(response => {
                console.log(response.data)
                window.location.href = response.data.progress_url
            }).catch(error => {
                console.log('oops problem starting free crawl')
                console.log(error.response)
            })
        }
    }

</script>